import React from 'react';
import { connect } from 'react-redux';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import * as cafeActions from '../../../../redux/cafes/actions';
import Spin from '../../../../components/loading';
import AlertAndConfirmation from '../../../../utils/AlertAndConfirmation';

const deleteRow = props => {
  props.deleteCafeUser(props.userId).then(() => {
    AlertAndConfirmation({
      title: '',
      text: locales('titles.deletedSuccessfully'),
      type: 'success'
    });
    props.closeModal();
  });
};

const DeleteUserModal = props => {
  let { loading, error, message, failed, fullName = '' } = props;
  return (
    <>
      <Modal id="financial-transaction-modal" size="xl" isOpen={props.isOpen}>
        <ModalHeader>
          <div className="row">
            <div className="col-11">{locales('titles.deleteCafeUser')}</div>
            <div className="col-1 text-left">
              <a
                href="#"
                className=""
                onClick={event => {
                  event.preventDefault();
                  props.closeModal();
                }}
              >
                <i className="fas fa-times"></i>
              </a>
            </div>
          </div>
        </ModalHeader>
        <ModalBody>
          <Spin spinning={loading}>
            <article>
              {error && <div className="alert alert-danger">{locales('messages.server.error')}</div>}
              {failed && <div className="alert alert-danger">{message}</div>}
              <div className="col-12 p-0">
                <div className="col-12 p-0">{locales('messages.userDeleteAlert', { fullName })} ؟</div>
              </div>
            </article>
          </Spin>
        </ModalBody>
        <ModalFooter>
          <button className="btn btn-danger mx-1" onClick={() => deleteRow(props)}>
            {locales('labels.yes')}
          </button>
          <button className="btn btn-success mx-1" onClick={() => props.closeModal()}>
            {locales('labels.no')}
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};
const mapStateToProps = state => {
  return {
    loading: state.cafesReducer.deleteCafeUserLoading,
    error: state.cafesReducer.deleteCafeUserError,
    failed: state.cafesReducer.deleteCafeUserFailed,
    message: state.cafesReducer.deleteCafeUserMessage
  };
};
const mapDispatchToProps = dispatch => {
  return {
    deleteCafeUser: id => dispatch(cafeActions.deleteCafeUser(id))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeleteUserModal);
